module.exports = __webpack_public_path__ + "epilace_3_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/epilace_3_before.jpg
// module id = 948
// module chunks = 0